import { documentSchema } from './IDocument';
import { ILegalRequirementDeadline } from './ILegalRequirement_deadlines';
import { z } from 'zod';
import type { ILegalRequirementTemplate } from './ILegalRequirementTemplate';

export const legalRequirementSchema = z.object({
  idLegalRequirement: z.number(),
  idLegalPhase: z.number(),
  LegalRequirement: z.string(),
  canUploadFilesClient: z.boolean(),
  canUploadFilesEmployees: z.boolean(),
  enableError: z.boolean(),
  enableFreeTextError: z.boolean(),
  sendMail: z.boolean(),
  EmailSubject: z.string().nullable(),
  EmailBody: z.string().nullable(),
  TextOfError: z.string().nullable(),
  hasError: z.boolean(),
  isComplete: z.boolean(),
  Position: z.number(),
  idLegalRequirementState: z.number(),
  User_idUser: z.number().nullable(),
  InfoText: z.string().nullable(),
  DocumentArrayClient: z.array(documentSchema).optional(),
  DocumentArrayEmployees: z.array(documentSchema).optional(),
  LegalRequirementState: z.string().optional(),
  Employee_idUser: z.number().optional(),
  Notary_idUser: z.number().optional(),
  idUserGroup: z.number().optional().nullable(),
  idLegalTransactionState: z.number().optional(),
  idLegalTransaction: z.number().optional(),
  Title: z.string().optional(),
  Closed_at: z.string().optional(),
  idCourt: z.number().optional(),
  idCourtRole: z.number().optional(),
  Court: z.string().optional(),
  CourtRole: z.string().optional(),
  initialProcessingTime: z.number(),
  actualProcessingTime: z.number().optional(),
  DeadlineFullfilledAt: z.string().optional(),
  idLegalRequirementTemplate: z.number().optional(),
  ManualProcessingTime: z.boolean(),
  UserDeadlineNotified: z.boolean().optional(),
  isInterneLegalRequirement: z.boolean(),
  sendInternLegalRequirementMail: z.boolean(),
  isEmailSent: z.boolean(),
  sendEmailAgain: z.boolean(),
});

export type ILegalRequirement = z.infer<typeof legalRequirementSchema>;

export interface ILegalRequirementFullObject extends ILegalRequirement {
  DeadlineArray?: ILegalRequirementDeadline[];
}

export const isLegalRequirement = (
  requirement: ILegalRequirement | ILegalRequirementTemplate
): requirement is ILegalRequirement => {
  return 'Title' in requirement;
};
